import React from "react";

const Services = () => {
  const services = [
    {
      name: "Intelligent Process Automation",
      desc: "Eliminate repetitive manual tasks in finance, HR, and operations. I automate invoice processing, streamline report generation, and reduce manual data entry to increase efficiency.",
      icon: "fas fa-robot"
    },
    {
      name: "AI-Powered Customer Experience",
      desc: "Transform customer service and engagement with intelligent chatbots and virtual assistants. Provide 24/7 support, reduce agent workload, and personalize customer interactions at scale.",
      icon: "fas fa-headset"
    },
    {
      name: "Supply Chain & Operations Optimization",
      desc: "Forecast demand, optimize inventory, improve logistics, and implement predictive maintenance using predictive analytics and machine learning. I help you tackle core operational challenges in manufacturing and logistics.",
      icon: "fas fa-truck-loading"
    },
    {
      name: "Strategic AI Roadmapping",
      desc: "A comprehensive engagement to assess organizational readiness, identify and prioritize the highest-ROI opportunities, and deliver a practical, phased implementation plan. I will be your strategic advisor from day one.",
      icon: "fas fa-map-signs"
    }
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        <p className="text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">Professional Services</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          A Menu of Enterprise Solutions
        </h2>
        <div className="row gy-4 mt-5">
          {services.map((service, index) => (
            <div 
              className="col-sm-6 col-lg-4 wow fadeInUp" 
              key={index}
              data-wow-delay={`${index * 0.1}s`}
            >
              <div className="featured-box text-center px-md-4 py-5 hover-effect">
                <div className="featured-box-icon text-primary text-13 mb-4">
                  <i className={service.icon} />
                </div>
                <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                <p className="text-muted mb-0">{service.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .hover-effect {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          border-radius: 8px;
          height: 100%;
        }
        
        .hover-effect:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.1);
        }
        
        .featured-box {
          background: white;
          height: 100%;
        }
      `}</style>
    </section>
  );
};

export default Services;